import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { CancelReservationDeskDetails } from './CancelReservationDeskDetails';

export const CancelReservationDetailsSection = ({
  reservationUserName,
  deskName,
  floorName,
  buildingName,
  children,
}: {
  reservationUserName: string | null | undefined;
  deskName: string;
  floorName: string | undefined;
  buildingName: string;
  children: React.ReactNode;
}): JSX.Element => (
  <DetailsSection>
    <DateSection>
      <CalendarIcon icon={faCalendar} width={16} />
      {children}
    </DateSection>
    <CancelReservationDeskDetails
      reservationUserName={reservationUserName}
      deskName={deskName}
      floorName={floorName}
      buildingName={buildingName}
    />
  </DetailsSection>
);

const DateSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CalendarIcon = styled(FontAwesomeIcon)`
  margin-top: 2px;
`;
